<template>
  <div>
    <h2>{{title}}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getMembersTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionMembershipMember && permissionMembershipMember.permission_id === permission.readWrite"
          @click.native="createMembers"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers">
              {{header.text}}
              <template v-if="header.icon">
                <a @click="sortDataTable">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort_date == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort_date == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in dataTable" :key="item.id">
            <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{ item.branch ? item.branch.branch_name_th : ''}}</td>
            <td>{{ item.topic ? item.topic.name_th : '' }}</td>
            <td>{{ item.title_th }}</td>
            <td>{{ item.updated_at | moment('DD-MM-YYYY') }}</td>
            <td>
              <a @click="showMembers(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
  import InputTextField from "../../../components/Input/InputTextField";
  import CircleButton from "../../../components/Button/CircleButton";
  import IconPencil from "../../../components/Icon/icon-pencil";
  import InputSearch from "../../../components/Input/InputSearch";
  import Paginate from "../../../components/Layout/Paginate";
  import {permissionMembershipMember, role} from "../../../util/Permission";
  import {mapState} from "vuex";
  import Swal from 'sweetalert';
  import Loading from 'vue-loading-overlay';
  export default {
    name: "MembersTable",
    components: {Paginate, InputSearch, IconPencil, CircleButton, InputTextField, Loading},
    data(){
      return{
        title : 'Member Information',
        isLoading : false,
        headers : [
          {text : 'No.',icon : null},
          {text : 'Branch',icon : null},
          {text : 'Topic',icon : null},
          {text : 'Detail',icon : null},
          {text : 'Update date',icon : true},
          {text : 'edit',icon : null},
        ],
        dataTable : [],
        dataPaginate: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 1,
          total: 1,
          to: 1
        },
        permission : null,
        search : '',
        sort_date : 'desc',
      }
    },
    created() {
      this.permission = role;
      this.getMembersTable(1);
    },
    computed: {
      permissionMembershipMember,
    },
    methods:{
      goToMembersEdit(){
        this.$router.push('/members/edit');
      },
      getMembersTable(page){
        this.isLoading = true;
        this.$store.dispatch("Members/getMembers",{
          page,
          search : this.search,
          sort_date : this.sort_date,
        }).then(res=>{
          if(res.response_code === 200){
            this.dataTable = res.result.data
          }else{
            Swal(res.response_msg);
          }
          this.isLoading = false;
        })
      },
      async changePage(val){
        this.isLoading = true;
        this.dataPaginate.current_page = val;
        await this.getMembersTable(this.dataPaginate.current_page);
        this.isLoading = false;
      },
      createMembers(){
        this.$store.dispatch("Members/clearFormData").then(()=>{
          this.goToMembersEdit();
        });
      },
      showMembers(id){
        this.isLoading = true;
        this.$store.dispatch("Members/showMembers",id).then(res=>{
          if(res.response_code == 200){
            this.$store.dispatch("Members/setFormMembers",res.result).then(()=>{
              this.goToMembersEdit();
            })
          }else{
            Swal(res.response_msg);
          }
          this.isLoading = false;
        });
      },
      searchInput(val){
        this.search = val;
      },
      sortDataTable(){
        this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
        this.getMembersTable(1);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/table.css";
  @import "../../../assets/css/variables";
  .branch-data{
    background-color: transparent;
    margin: 20px;
  }
</style>
